import {NgOptimizedImage} from "@angular/common";
import {Component, inject, ViewEncapsulation} from "@angular/core";
import {RouterLink} from "@angular/router";
import {map} from "rxjs";
import {rxSafeResource} from "../../helpers/ResourceHelpers";
import {HeaderComponent} from "../../layout/header/header.component";
import {TeamMemberGender} from "../../models/Team/TeamMember";
import {SafeHtmlPipe} from "../../pipes/safe-html.pipe";
import {TeamService} from "../../services/api/team.service";
import {TimelineService} from "../../services/api/timeline.service";

@Component({
  selector: "app-about-us",
  templateUrl: "./about-us.component.html",
  styleUrl: "./about-us.component.scss",
  encapsulation: ViewEncapsulation.None,
  imports: [
    HeaderComponent,
    SafeHtmlPipe,
    NgOptimizedImage,
    RouterLink,
  ],
})
export class AboutUsComponent {
  protected readonly TeamMemberGender = TeamMemberGender;

  private readonly teamService = inject(TeamService);
  private readonly timelineService = inject(TimelineService);

  protected readonly applicationContactFormSubject = $localize`Bewerbung`;

  protected readonly team = rxSafeResource({
    stream: () => this.teamService.getTeam().pipe(map(t => t.entries)),
    defaultValue: [],
  });
  protected readonly timeline = rxSafeResource({
    stream: () => this.timelineService.getTimeline().pipe(map(t => t.entries)),
    defaultValue: [],
  });
}
